import { BaseApiClient } from './base-client';

/**
 * Achievements API - методы для достижений
 */
export class AchievementsApi extends BaseApiClient {

  /**
   * Get all achievements with progress
   */
  async getAchievements(forceRefresh?: boolean): Promise<any> {
    const headers: Record<string, string> = {};
    if (forceRefresh) {
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    }
    const response = await this.client.get('/api/achievements', { headers });
    return response.data;
  }

  /**
   * Claim achievement reward
   */
  async claimAchievement(achievementId: string, reward: number): Promise<any> {
    const response = await this.client.post(`/api/achievements/${achievementId}/claim`, { reward });
    return response.data;
  }

  /**
   * Unlock achievement by ID
   */
  async unlockAchievement(achievementId: string): Promise<any> {
    const response = await this.client.post(`/api/achievements/${achievementId}/unlock`, {});
    return response.data;
  }

  /**
   * Track night shift achievement
   */
  async trackNightShift(): Promise<any> {
    const response = await this.client.post('/api/achievements/night-shift/track', {});
    return response.data;
  }
}
